import { MessageCircle } from "lucide-react";
import { useBrand, waLink } from "@/hooks/useSiteContent";

export function WhatsAppButton() {
  const brand = useBrand();
  return (
    <a
      href={waLink(
        brand.whatsapp,
        "Olá! Vim pelo site da Contato e quero mais informações.",
        "botão flutuante",
      )}
      data-wa-loc="botao-flutuante"
      target="_blank"
      rel="noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 right-6 z-50 inline-flex size-14 items-center justify-center rounded-full bg-brand-lime text-brand-yellow-foreground shadow-xl transition-transform hover:scale-110"
    >
      <MessageCircle className="size-7" />
    </a>
  );
}
